import ReactModal from "react-modal";
import { componentStyles } from "./product-modal.scss";
import ModalScreen from "./modal-screen/modal-screen";

const productModal = (props) => {
  const { isModalOpen, closeProductModal, product, beforeSubmitCallback, translate, modalTitle, modalSubTitle } = props;
  return (
    <ReactModal
      className="product-modal"
      overlayClassName="product-modal-overlay"
      bodyOpenClassName="modal-open"
      isOpen={isModalOpen}
    >
      <div className="modal-content" onClick={closeProductModal}>
        <ModalScreen
          closeProductModal={closeProductModal}
          product={product}
          translate={translate}
          beforeSubmitCallback={beforeSubmitCallback}
          modalTitle={modalTitle}
          modalSubTitle={modalSubTitle}
        />
      </div>

      <style jsx>{componentStyles}</style>
    </ReactModal>
  );
};

export default productModal;
